import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { shortId } from "@/lib/formatters";
import { cn } from "@/lib/utils";

/** Monospace id with copy. Short form in tables, full id on hover and in the clipboard. */
export function IdBadge({ id, full = false, className }: { id: string | null | undefined; full?: boolean; className?: string }) {
  const [copied, setCopied] = useState(false);
  if (!id) return <span className="text-muted-foreground">—</span>;
  return (
    <span className={cn("group/id inline-flex max-w-full items-center gap-1 font-mono text-[11.5px]", className)} title={id}>
      <span className="truncate">{full ? id : shortId(id)}</span>
      <button
        type="button"
        aria-label={`Copy ID ${id}`}
        className="shrink-0 rounded p-0.5 text-muted-foreground opacity-0 hover:bg-muted hover:text-foreground focus-visible:opacity-100 group-hover/id:opacity-100"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          void navigator.clipboard?.writeText(id).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1200);
          });
        }}
      >
        {copied ? <Check className="size-3" /> : <Copy className="size-3" />}
      </button>
    </span>
  );
}
